// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__0i5vy","backButtonContent":"BackButton_backButtonContent__Gea3i","backButtonText":"BackButton_backButtonText__zuuYY"};